






































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { mapMutations } from 'vuex';

@Component({
    methods: {
        ...mapMutations('layout', ['changeTitle']),
    },
})
export default class FileManagement extends Vue {
    @Prop({ required: false })
    title!: string;

    DClocation: number | undefined = undefined;

    inputLength: number = this.title === 'Facturación' ? 25 : 22;
    headers: any[] = [
        { text: 'Cliente', sortable: false, value: 'name' },
        { text: 'RIF', sortable: false, value: 'rif' },
    ];
    fileRules: any[] = [v => !!v || 'Requerido'];
    loadingButton: boolean = false;
    snackbar: boolean = false;
    snackbarError: boolean = false;
    snackbarFieldError: boolean = false;
    filePath: string = '';
    menu: boolean = false;
    valid: boolean = true;
    file: any;
    singleSelect: boolean = true;
    selected: any[] = [];
    picker: string = '';
    date: string = '';
    customerSelected: any = {
        id: null,
        name: null,
    };
    uploadFiles: boolean = true;
    itemsPerPage: number[] = [10, 20, 50, 100];
    loadingCustomers: boolean = false;
    loadingText: string = 'Obteniendo los clientes, espere un momento por favor';
    noDataText: string = 'No hay clientes disponibles';
    limit: number = this.itemsPerPage[0];
    start: number = 1;
    page: number = 1;
    search: string = '';
    rules: {
        defaultRules: any[];
        defaultArrayRules: any[];
    } = {
        defaultRules: [(v: any) => !!v || 'Requerido'],
        defaultArrayRules: [(v: any) => !!v.length || 'Requerido'],
    };
    $refs!: {
        form1: any;
    };
    maintenanceReportId: number = 1;
    healthReportId: number = 2;
    reportTypes: { value: number; text: string }[] = [
        { value: this.maintenanceReportId, text: 'Mantenimiento' },
        { value: this.healthReportId, text: 'Salud y Gestión' },
    ];
    reportTypeSelected: number = 0;

    showFileName() {
        this.filePath = this.$store.state.fileResponse;
    }

    onFileChange(e) {
        if (e === null) {
            this.file = null;
        } else {
            this.file = e;
        }
    }

    getMonthName(monthNumber: string) {
        switch (monthNumber) {
            case '01':
                return 'Enero';
            case '02':
                return 'Febrero';
            case '03':
                return 'Marzo';
            case '04':
                return 'Abril';
            case '05':
                return 'Mayo';
            case '06':
                return 'Junio';
            case '07':
                return 'Julio';
            case '08':
                return 'Agosto';
            case '09':
                return 'Septiembre';
            case '10':
                return 'Octubre';
            case '11':
                return 'Noviembre';
            case '12':
                return 'Diciembre';
        }
    }

    async mounted() {
        //@ts-ignore
        this.changeTitle({ title: 'Administración', route: ['REPORTES'] });
        await this.getCustomers();
    }

    async getCustomers() {
        this.loadingCustomers = true;
        let customersOptions: { limit: number; start: number; keyword: string } = {
            limit: this.limit,
            start: this.page,
            keyword: this.search,
        };
        await this.$store.dispatch('getCustomers', customersOptions);
        this.loadingCustomers = false;
    }

    get customers() {
        return this.$store.state.customers.results;
    }

    get pages() {
        if (this.$store.state.customers.pages !== undefined) {
            if (this.page > this.$store.state.customers.pages) {
                this.page = this.$store.state.customers.pages;
                if (this.page !== 0) {
                    this.getCustomers();
                } else {
                    this.page = 1;
                }
            }
            return this.$store.state.customers.pages;
        } else {
            return 1;
        }
    }

    dateChange() {
        const date = this.picker.split('-');
        this.date = `${this.getMonthName(date[1])}, ${date[0]}`;
        return this.date;
    }

    changeCustomer(customerSelected: any) {
        if (this.customerSelected.id) {
            this.customerSelected = {};
        } else {
            this.customerSelected = customerSelected;
        }
    }

    get form1IsValid() {
        return this.$refs.form1.validate();
    }

    async uploadFile() {
        if (this.form1IsValid) {
            let formData = new FormData();
            formData.set('file', this.file, this.file.name);

            const fileType =
                this.reportTypeSelected === this.maintenanceReportId
                    ? 'maintenance-reports'
                    : 'health-reports';

            this.loadingButton = true;
            this.$store
                .dispatch('uploadMaintenanceReportFile', {
                    date: this.picker,
                    formData,
                    location: this.DClocation,
                })
                .then(() => {
                    this.showFileName();
                    this.snackbar = true;
                    this.loadingButton = false;
                    this.$refs.form1.reset();
                })
                .catch(() => {
                    this.snackbarError = true;
                    this.loadingButton = false;
                });
        }
    }
}
